import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostListener,
  Input,
  Output,
} from '@angular/core';
import { CurrentUserService } from '@macs-frontend/web-macs/core/services/current-user.service';
import { AuthService } from '../../../../auth/services/auth.service';

@Component({
  /* eslint-disable-next-line @angular-eslint/component-selector */
  selector: 'cc-header',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent {
  @Input() headerTitle = 'title';
  @Output() toggleSidebar: EventEmitter<any> = new EventEmitter();

  showUserActionsMenu = false;

  totalNotificationCount = 0;

  @HostListener('document:mousedown')
  documentMouseDown() {
    this.showUserActionsMenu = false;
  }

  handleSidebarIconClick() {
    this.toggleSidebar.emit();
  }

  logout() {
    this.authService.logout();
  }

  updateTotalCount(countDelta: number) {
    this.totalNotificationCount += countDelta;
  }

  constructor(
    private authService: AuthService,
    public currentUserService: CurrentUserService,
  ) {}
}
